<template>
    <div>
        <div class="uk-modal-header">
            <h2>Login</h2>
        </div>
        <div class="modal-body">
            <form class="uk-form" role="form" @submit.prevent.stop="login">
                <form-input
                    id="email"
                    v-model="email"
                    name="email"
                    type="email"
                    :error="has_error('email')"
                    :required="true"
                    placeholder="Email"
                    size="large"
                    width="1-1"
                    @input="update_email"
                />
                <form-input
                    id="password"
                    v-model="password"
                    name="password"
                    type="password"
                    :error="has_error('password')"
                    :required="true"
                    placeholder="Password"
                    size="large"
                    width="1-1"
                />

                <div class="uk-text-center uk-margin-top">
                    <feedback-button
                        type="submit"
                        :status="feedback_status"
                        :waiting="loading"
                        :single-use="false"
                        color="primary"
                        size="large"
                        @click.prevent="login"
                    >
                        <template v-slot:message>
                            <div
                                :class="{ 'uk-text-danger': (feedback_status === false) }"
                            >
                                {{ feedback_message }}
                            </div>
                        </template>
                        Login
                    </feedback-button>
                </div>
            </form>
        </div>
        <div class="uk-modal-footer uk-text-center">
            <base-button
                flavor="link"
                size="small"
                class="uk-margin-top"
                @click.native.prevent="goto('password')"
            >
                Shoot! Forgot my password...
            </base-button>
        </div>
    </div>
</template>

<script>
import is_panel from "./IsPanel"

import FormInput from "../../ui/FormInput"
import FeedbackButton from "../../ui/FeedbackButton"
import BaseButton from "../../ui/BaseButton"

export default {
    mixins: [is_panel],
    components: {
        FormInput,
        FeedbackButton,
        BaseButton
    },
    methods: {
        login () {
            // patch to make sure fields are set correctly before post
            const focused_element = document.activeElement
            if(focused_element) {
                if(focused_element.name === "email") this.email = focused_element.value
                if(focused_element.name === "password") this.password = focused_element.value
            }
            if(!this.password) {
                this.add_error("password", "The password field seems to be empty? If it was auto-filled by your browser, can you please try typing-it in? Either way, please let Dan/Jack/Jean know - thank you!")
            } else {
                this.loading = true
                setTimeout(() => {
                    this.clear_all_errors()
                    this.$store.dispatch("LOGIN", {
                        email: this.email,
                        password: encodeURIComponent(this.password)
                    }).then(() => {
                        this.$emit("input", "")
                        this.password = ""
                        this.$store.dispatch("UNREQUEST_LOGIN")
                    }).catch(this.receive_error).then(() => {
                        this.loading = false
                    })
                }, this.autofill_timeout) // need a timeout slightly longer than input field's debounce. Otherwise, Enter key happens before this.field is updated!
            }
        }
    },
    data () {
        return {
            password: "",
            handles_feedback: true
        }
    }
}
</script>
